import React from 'react'
import moment from 'moment'
import BodyText from 'LuxKit/Typography/BodyText'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'

interface Props {
  bookByDate: string
  travelByDate: string
}

export function BnblPackageDates(props: Props) {
  const { bookByDate, travelByDate } = props

  return (
    <Group direction="vertical" gap={8} tabletGap={16}>
      <BodyText variant="medium">Our offers are live for a limited time. Secure your dream escape at a great price! No dates yet? Reserve the price now and pick dates later.</BodyText>

      <Group gap={0} direction="vertical">
        <Heading variant="heading5" style={{ marginBottom: 8 }}>How it works</Heading>
        <BodyText variant="medium">
          <strong>1. Secure your escape today</strong> to lock in the price.
        </BodyText>
        <BodyText variant="medium">
          <strong>2. Choose dates</strong> anytime before <strong>{moment(bookByDate).format(DMY_CASUAL_FORMAT)}</strong> in your account.
        </BodyText>
        <BodyText variant="medium">
          <strong>3. Manage your booking online</strong> and travel by <strong>{moment(travelByDate).format(DMY_CASUAL_FORMAT)}</strong>.
        </BodyText>
      </Group>

      <Group direction="vertical">
        <MessageBanner kind="informational-primary" density="compact">
          <Group direction="horizontal" gap={8} verticalAlign="center">
            <LineInfoCircleIcon />
            <BodyText variant="medium">
              Subject to availability and surcharges (peak period or property-specific). Any surcharges will be shown before confirming your dates.
            </BodyText>
          </Group>
        </MessageBanner>
      </Group>
    </Group>
  )
}
